import { useNavigate } from "react-router-dom";

import { TextButton } from "@/atoms/text-button/TextButton";
import { useTranslation } from "@/core/i18n";
import { storage } from "@/modules/storage";
import { isNativeMobileApp } from "utils/platform.helpers";

type AnonymousLoginProps = {
  /** Whether the current user is already authorized */
  isAuthorized?: boolean;
  /** Optional override for the trailing icon */
  /** Whether to render with extra-small text sizing */
  xsText?: boolean;
  /** Optional class names for positioning/styling */
  className?: string;
};

export const AnonymousLogin = ({
  isAuthorized = false,
  xsText = true,
  className,
}: AnonymousLoginProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const comingFromDeepLink = storage.getItem("platformId");

  const shouldShow = isAuthorized || (isNativeMobileApp() && !comingFromDeepLink);

  if (!shouldShow) return null;

  const handleNavigation = () => {
    if (isAuthorized) {
      if (isNativeMobileApp()) {
        navigate("/signin/platform-search");
      } else {
        navigate("/signin/name");
      }

      return;
    }

    navigate("/signin/browse-practice");
  };

  return (
    <TextButton xsText={xsText} className={className} onClick={handleNavigation}>
      {isAuthorized ? t("anonymousLogin.findDifferentLocation") : t("anonymousLogin.skipLogin")}
    </TextButton>
  );
};
